import classNames from 'classnames';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { Box } from '@jsmdg/yoshi';
import { usePaybackScrid } from '../hooks/usePaybackScrid';
import { useUserConsent } from '../hooks/useUserConsent';
import { type FooterContext } from '../types';
import { ChatBot } from './ChatBot/ChatBot';
import { CheckoutFooter } from './CheckoutFooter/CheckoutFooter';
import { ContractCancellationButton } from './ContractCancellationButton/ContractCancellationButton';
import { FooterLinkList } from './FooterLinkList/FooterLinkList';
import { Newsletter } from './Newsletter';
import { PaymentMethods } from './PaymentMethods/PaymentMethods';
import { SocialApps } from './SocialApps/SocialApps';
import styles from './Footer.module.scss';

const Footer = (): JSX.Element => {
    const { areSocialAppsEnabled, enabledPaymentMethods, isNewsletterEnabled, showCheckoutFooter } =
        useFragmentContext<FooterContext>();

    usePaybackScrid();
    useUserConsent();

    return (
        <Box isFluid>
            {showCheckoutFooter ? (
                <CheckoutFooter />
            ) : (
                <footer>
                    {isNewsletterEnabled && <Newsletter />}
                    {areSocialAppsEnabled && <SocialApps />}
                    <div className={classNames('p-3x pb-1x', styles.highlightedBg)}>
                        <ContractCancellationButton layout="default" />
                        <FooterLinkList />
                        <PaymentMethods
                            enabledMethods={enabledPaymentMethods}
                            className="justify-content-center"
                        />
                    </div>
                </footer>
            )}
            <ChatBot />
        </Box>
    );
};

export { Footer };
